<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
            prop="name"
          label="字段名称">
          <a-input placeholder="请输入字段名称" readOnly v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
            prop="nameEn"
          label="字段英文">
          <a-input placeholder="请输入字段英文"  v-model="model.nameEn" />
        </a-form-model-item>
        <a-form-model-item
            prop="required"
          label="必填">
          <a-radio-group v-model="model.required">
            <a-radio value="">不可配置</a-radio>
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
            prop="exportInfo"
          label="导出基本信息">
          <a-radio-group v-model="model.exportInfo">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
            prop="exportData"
          label="导出采集数据">
          <a-radio-group v-model="model.exportData">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "PatientFieldModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          nameEn:[baseRules.required],
          exportInfo:[baseRules.required],
          exportData:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/management/patientField/add",
          edit: "/management/patientField/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>